import React from "react";
import { Localize } from "components/service";
import UserDiamondStatusSelect from "./user-diamond-status-select";

const UserBestSalesmanSelect = (props) => (
    <UserDiamondStatusSelect
        name="best_salesman"
        label={ Localize({ children: "FORMS.Input_Label_BestSalesman" }).props.children }
        { ...props }
    />
);

export default UserBestSalesmanSelect;
